import ContainerButtons from "./ContainerButtons";
import Containerplatos from "./Containerplatos";
import Footer from "./Footer";
import Header from "./Header"
import React from 'react';
import { useAuth } from "../context/authContext";

function Home(props) {
  const authContext=useAuth()
  console.log(props.data)
  return (
    <div className="App">
      <Header/>
      <ContainerButtons/>
      <Containerplatos tabla={props.data}/>
      <Footer/>
    </div>
  )
}

export default Home
